import React, { useEffect, useState } from "react";
import { Link } from "@quintype/components";
import { shape, string, array } from "prop-types";
import { postTags } from "../../utils/post-tags";
import BookmarkPopup from "../../molecules/bookmark-popup";
import "./tags.m.css";
import { LoadmoreButton } from "../../atoms/Loadmore-btn";
import useStorage from "../../../hook/useStorage";
import { PopoverElement } from "../../atoms/popover-element";
import { deleteUserFlag } from "../../../hook/delete-user-flag";


const Tag = ({ tag, place }) => {
  const [show, setShow] = useState(true);
  const [citytagChecked, setCitytagChecked] = useState(false);
  const [op, setOp] = useState(true);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [isBmTag, setIsBmTag] = useState(false)
  const [alreadyBMtags, setAlreadyBMtags] = useState(true);
  const [checkUser] = useStorage();
  const convertedString = tag.name.toLowerCase().replace(/ /g, "-");

  useEffect(() => {
    let isMounted = true;
    if (typeof window === 'undefined') {
      return;
    } else {
      setTimeout(() => {
        const storedTags = JSON.parse(localStorage.getItem("tags") || "[]");
        const storedTagsLower = storedTags.map((tag) => tag.toLowerCase());
        if (storedTags.includes(tag.name) === true || storedTagsLower.includes(tag.name.toLowerCase())) {
          setIsBmTag(true)
        }
      }, 720)
    }
    return () => {
      isMounted = false;
    };
  }, [])

  return (
    place !== "citytags-profilepage" ?
    //This is the code block for the tags in the story page and profilepage if some tags are already selected
    <div styleName="tag-holder">
      <div styleName="tag-name" className="tag-name">
        <Link href={"/topic/" + (tag.slug ? tag.slug : convertedString)} styleName="story-tag" className="story-tag" title={tag.name}>
          {tag.name.length >= 21 ? tag.name.slice(0, 25).concat("...") : tag.name}
        </Link>
      </div>
      {isBmTag && alreadyBMtags ? <div onClick={(e) => {
        if (checkUser) {
          e.preventDefault();
          postTags(e, tag.name, false)
          setAlreadyBMtags(false)
          setShowLoginPopup(false)
        } else {
          console.log("user need to be logged in to perform this action");
          setShowLoginPopup(true)
        }
      }} styleName="tag-btn" className="tag-btn">
        {checkUser ?
          (!show ? <button styleName="add-tag tag-btn-wrapper" className="tag-btn-wrapper add-tag" title="Seuraa aihetta"><i className="ri-add-line"></i></button>
            : <button styleName="tag-checked tag-btn-wrapper" className="tag-btn-wrapper tag-checked" title="Lopeta aiheen seuraaminen"><i className="ri-check-line"></i></button>)
          : (<button styleName="add-tag tag-btn-wrapper" className="tag-btn-wrapper add-tag" title="Seuraa aihetta"><i className="ri-add-line"></i></button>)}
      </div> :
        <div onClick={(e) => {
          if (checkUser) {
            e.preventDefault();
            setShow(!show)
            setOp(!op)
            postTags(e, tag.name, op)
            setShowLoginPopup(false)
          } else {
            console.log("user need to be logged in to perform this action");
            setShowLoginPopup(true)
          }
        }} styleName="tag-btn" className="tag-btn">
          {checkUser ?
            (show ? <button styleName="add-tag tag-btn-wrapper" className="tag-btn-wrapper add-tag" title="Seuraa aihetta"><PopoverElement showContents={false} user_flag="tag_user_flag" anchor="ri-add-line" /></button>
            : <button styleName="tag-checked tag-btn-wrapper" className="tag-btn-wrapper tag-checked" title="Lopeta aiheen seuraaminen"><PopoverElement user_flag="tag_user_flag" anchor="ri-check-line" /></button>)
          : (<button styleName="add-tag tag-btn-wrapper" className="tag-btn-wrapper add-tag" title="Seuraa aihetta"><i className={`ri-add-line`}></i></button>)}        </div>
      }
      {showLoginPopup ? <BookmarkPopup closePopup={() => setShowLoginPopup(false)} feature={"save-tag"} /> : ""}
      {/*Code block for debugging Popover <button style={{cursor:"pointer"}} onClick={()=>deleteUserFlag("tag_user_flag")}>ResetTag</button>*/}
    </div>
    :
    //This is the code block for showing the city tags in the profile page if no tags are selected
    <div styleName="tag-holder">
    <div styleName="tag-name" className="tag-name">
      <Link href={"/topic/" + (tag.slug ? tag.slug : convertedString)} styleName="story-tag" className="story-tag" title={tag.name}>
        {tag.name.length >= 21 ? tag.name.slice(0, 25).concat("...") : tag.name}
      </Link>
    </div>
      <div onClick={(e) => {
          e.preventDefault();
          setOp(!op)
          setCitytagChecked(!citytagChecked)
          postTags(e, tag.name, op)
          setShowLoginPopup(false)
      }} styleName="tag-btn" className="tag-btn">
        {!citytagChecked ?
          <button styleName="add-tag tag-btn-wrapper" className="tag-btn-wrapper add-tag" title="Seuraa aihetta"><PopoverElement showContents={false} user_flag="tag_user_flag" anchor="ri-add-line" /></button>
        : <button styleName="tag-checked tag-btn-wrapper" className="tag-btn-wrapper tag-checked" title="Lopeta aiheen seuraaminen"><PopoverElement user_flag="tag_user_flag" anchor="ri-check-line" /></button>}
      </div>
  </div>
  )
};

Tag.propTypes = {
  tag: shape({
    slug: string,
    name: string
  })
};

const Tags = ({ tags = [], place, hideTags, deleteAllTags }) => {
  const [checkUser] = useStorage();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [seuraamaniAiheetUrl, setSeuraamaniAiheetUrl] = useState("https://ilkkapohjalainen.fi/seuraamani-aiheet");
  useEffect(() => {
    if (typeof window === 'undefined') { }
    else {
      if (window.location.href.indexOf("localhost") > -1) {
        setSeuraamaniAiheetUrl("http://localhost:3000/seuraamani-aiheet")
      } else if (window.location.href.indexOf("qtstage") > -1){
        setSeuraamaniAiheetUrl("https://imediat-web.fiare.qtstage.io/seuraamani-aiheet")
      } else {
        setSeuraamaniAiheetUrl("https://ilkkapohjalainen.fi/seuraamani-aiheet")
      }
     }
  }, [])

  const filterTags = (tags) => {
    const tagMap = new Map();
    tags.forEach((tag) => {
      const lowerCaseName = tag.name.toLowerCase();
      const existingTag = tagMap.get(lowerCaseName);
      if (!existingTag || (existingTag.name[0] !== existingTag.name[0].toUpperCase() && tag.name[0] === tag.name[0].toUpperCase())) {
        tagMap.set(lowerCaseName, tag);
      }
    });
    return Array.from(tagMap.values());
  };

  const filteredTags = filterTags(tags);

  return (
    filteredTags.length > 0 &&
    (<div  styleName={(checkUser && place == "story-page") ? "tag-container-no-margin" : "tag-container"} className="voice-no-read tag-container">
      {(place == "story-page" || place == "citytags-profilepage") ?
        (<>
          <p styleName="tag-text" className="tag-text">Seuraa artikkelin aiheita</p>
        </>
        )
        :
        <p styleName="tag-text-followed-topics">Seuraamani aiheet</p>}
      <div styleName="tag-wrapper tags-container" className="tag-wrapper tags-container">
        {(place == "story-page" || place=="citytags-profilepage") ?
          filteredTags.map((tag, index) => {
            return (
              <Tag tag={tag} place={place} />
            );
          })
          :
          <div>

            {!hideTags ? (
              <>
              <div styleName="tags-container" className="tags-container">
                {
                  filteredTags.map((tag, index) => {
                    return (
                      <Tag tag={tag} place={place} />
                    );
                  })}
              </div>
              {filteredTags.length > 0 && <LoadmoreButton onClick={() => setShowDeletePopup(true)} btnText="Lopeta kaikkien seuraaminen" />}
              </>
            ) : (
              <p styleName="tags-unfollowed">Olet lopettanut kaikkien aiheiden seuraamisen.</p>
            )
            }
            {showDeletePopup ? <BookmarkPopup closePopup={() => setShowDeletePopup(false)} feature={"delete-all-tags"} deleteAll={deleteAllTags} tags={tags} /> : ""}
          </div>
        }
      </div>
    </div>)

  );
};

Tags.propTypes = {
  tags: array
};

export default Tags;
